import { Select } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useAppSelector } from '../../appStore';
import ContentConstants from '../../contentConstants';
import { ActionType, IValidationResult } from '../../models';
import { displayLogicQuestionToSelectOption, selectDisplayLogicQuestions } from '../../store/QuestionBranchingLogicSlice';
import { assertIsString } from '../../utilities/assertions';
import { ConditionText } from '../common';
import { QuestionBranchingLogicScope } from './QuestionBranchingLogicScope';

const showQuestionOption = {
	displayText: ContentConstants.DISPLAY_LOGIC_ACTION_TYPE_SHOW_QUESTION_LABEL,
	name: ActionType.ShowQuestion.toString(),
};

const hideQuestionOption = {
	displayText: ContentConstants.DISPLAY_LOGIC_ACTION_TYPE_HIDE_QUESTION_LABEL,
	name: ActionType.HideQuestion.toString(),
};

const branchToQuestionOption = {
	displayText: ContentConstants.DISPLAY_LOGIC_ACTION_TYPE_BRANCH_TO_QUESTION_LABEL,
	name: ActionType.BranchToQuestion.toString(),
};

const getActionTypeSelectOptions = ({ actionType, scope }: { actionType?: ActionType; scope: QuestionBranchingLogicScope }) => {
	const result = [];

	if (!actionType || actionType === ActionType.ShowQuestion || actionType === ActionType.HideQuestion) {
		result.push(showQuestionOption, hideQuestionOption);
	}

	if ((!actionType || actionType === ActionType.BranchToQuestion) && scope !== 'group') {
		result.push(branchToQuestionOption);
	}

	return result;
};

export const BranchingLogicRuleAction = ({
	newRule,
	actionType,
	destinationQuestionId,
	disabled,
	validationResult,
	questionDisplayOrder,
	scope,
	onActionTypeChange,
	onDestinationQuestionChange,
}: {
	newRule?: boolean;
	actionType: ActionType;
	destinationQuestionId?: number;
	disabled?: boolean;
	validationResult?: IValidationResult;
	questionDisplayOrder: number;
	scope: QuestionBranchingLogicScope;
	onActionTypeChange: (actionType: ActionType) => void;
	onDestinationQuestionChange: (questionId?: number) => void;
}) => {
	const actionTypeOptions = getActionTypeSelectOptions({ actionType: newRule ? undefined : actionType, scope });

	const destinationQuestionOptions = useAppSelector((state) =>
		selectDisplayLogicQuestions(state, { minDisplayOrder: questionDisplayOrder }),
	).map(displayLogicQuestionToSelectOption);

	const handleActionTypeChange = (values?: string | string[] | undefined) => {
		assertIsString(values);
		onActionTypeChange(+values);
		if (+values !== ActionType.BranchToQuestion) {
			onDestinationQuestionChange(undefined);
		}
	};

	const handleDestinationQuestionChange = (values?: string | string[] | undefined) => {
		assertIsString(values);
		onDestinationQuestionChange(+values);
	};

	return (
		<div className='row'>
			<div className='col-auto'>
				<Select
					selectSize='md'
					displayText={ContentConstants.DISPLAY_LOGIC_ACTION_TYPE_DROPDOWN_TEXT}
					onApply={handleActionTypeChange}
					selectedValue={actionType.toString()}
					items={actionTypeOptions}
					disabled={disabled}
				/>
			</div>
			{actionType === ActionType.BranchToQuestion && (
				<>
					<ConditionText className='col-auto'>to question</ConditionText>
					<div className='col-5'>
						<Select
							size='md'
							selectSize='xlg'
							dropdownSize='sm'
							displayText={ContentConstants.DISPLAY_LOGIC_ACTION_DESTINATION_QUESTION_DROPDOWN_TEXT}
							onApply={handleDestinationQuestionChange}
							selectedValue={destinationQuestionId?.toString()}
							items={destinationQuestionOptions}
							error={!validationResult?.isValid}
							message={validationResult?.errors}
						/>
					</div>
				</>
			)}
		</div>
	);
};
